import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useUser } from "@/context/userContext";
import { useGuestUser } from "@/context/GuestUserContext";

const PrivateRoute: React.FC = () => {
    const { user, loading: userLoading } = useUser();
    const { guestUser } = useGuestUser();
    const location = useLocation();

    // Debug output (optional)
    console.log("🔐 PrivateRoute check:", {
        user,
        guestUser,
        userLoading,
    });

    // Show loading while auth is being verified
    if (userLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground">
                <span className="brand-pill qit-loading-pill qit-loading-pill-page" aria-label="Loading" />
            </div>
        );
    }

    const isGuestOnly = !!guestUser && !user;
    const isNotLoggedIn = !user;

    // Block guest users
    if (isGuestOnly) {
        return <Navigate to="/" replace state={{ from: location }} />;
    }

    // Block unauthenticated users
    if (isNotLoggedIn) {
        return <Navigate to="/" replace state={{ from: location }} />;
    }

    // ✅ Access granted to authenticated user
    return <Outlet />;
};

export default PrivateRoute;
